import storeConfig from '../../../../../store.config'

export const LoginRegister = () => {
  const handleGoToLogin = () => {
    window.location.href = `${storeConfig.loginUrl}?returnUrl=/account`
  }

  return (
    <div className="absolute right-0 top-10 md:top-[65px] 3xl:top-[72px] max-w-[calc(100vw-80px)] md:max-w-[calc(100vw-160px)] opacity-0 -z-1 flex flex-row bg-white rounded-lg shadow-[0px_-1px_5px_0px_rgba(0,0,0,0.16),0px_2px_16px_0px_rgba(0,0,0,0.08)] overflow-hidden dropdown-subheader-body">
      <div className="py-6 px-4 w-[292px] space-y-2">
        <button
          className="btn btn-yellow w-full font-semibold account-button cursor-pointer"
          onClick={handleGoToLogin}
        >
          Accedi
        </button>
        <p className="text-center text-xs !leading-[130%] tracking-[0.048px] pt-1">
          Nuovo cliente?&nbsp;
          <a
            className="underline font-semibold text-black"
            href={`${storeConfig.registrationUrl}`}
          >
            Inizia qui
          </a>
        </p>
      </div>
    </div>
  )
}
